export function buildChartAdvisorPayload({
  auditSummary,
  schema,
  sampleRows,
  currentChart,
}) {
  return {
    auditSummary,
    schema,
    sampleRows: (sampleRows || []).slice(0, 5),
    currentChart: currentChart
      ? {
          key: currentChart.metadata?.id || currentChart.metadata?.name,
          name: currentChart.metadata?.name,
        }
      : null,
  }
}

export function aiChartAdvisor(input) {
  const payload = buildChartAdvisorPayload(input)
  // TODO(OpenAI): replace the mocked response with a client-side call to an LLM endpoint.
  // Keep the payload contract stable so UI code does not need to change when the model is added.
  return {
    status: 'mocked',
    suggestions: [
      'Your dataset looks usable; apply safe fixes before mapping dimensions.',
      'Start with the first recommended chart and validate axis labels.',
      `Current chart context: ${payload.currentChart?.name || 'none selected'}`,
      `Rows reviewed by assistant: ${payload.sampleRows.length}`,
      `Warnings found: ${(payload.auditSummary?.warnings || []).length}`,
    ],
    payloadPreview: {
      ...payload,
      sampleRows: payload.sampleRows.slice(0, 3),
    },
  }
}
